const scrollToElement = (id) => {
  const yOffset = -80
  const element = document.getElementById(id)
  const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
  console.log(id, y)
  window.scrollTo({ top: y, behavior: 'smooth' })
}

export default scrollToElement
